// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2zM3o","open":"open___1cyYx","header":"header___2n4ju","content":"content___1yBG9","formCard":"formCard___2n9Uu"};